import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.some.js";
import { __decorate } from "tslib";
import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import { asyncRoutes, constantRoutes } from '@/router';
import store from '@/store';
const hasPermission = (roles, route) => {
  if (route.meta && route.meta.roles) {
    return roles.some(role => route.meta.roles.includes(role));
  } else {
    return true;
  }
};
export const filterAsyncRoutes = (routes, roles) => {
  const res = [];
  routes.forEach(route => {
    const r = {
      ...route
    };
    if (hasPermission(roles, r)) {
      if (r.children) {
        r.children = filterAsyncRoutes(r.children, roles);
      }
      res.push(r);
    }
  });
  return res;
};
let Permission = class Permission extends VuexModule {
  constructor() {
    super(...arguments);
    this.routes = [];
    this.dynamicRoutes = [];
  }
  SET_ROUTES(routes) {
    this.routes = constantRoutes.concat(routes);
    this.dynamicRoutes = routes;
  }
  GenerateRoutes(roles) {
    let accessedRoutes;
    if (roles.includes('Super Admin')) {
      accessedRoutes = asyncRoutes;
    } else {
      accessedRoutes = filterAsyncRoutes(asyncRoutes, roles);
    }
    this.SET_ROUTES(accessedRoutes);
  }
};
__decorate([Mutation], Permission.prototype, "SET_ROUTES", null);
__decorate([Action], Permission.prototype, "GenerateRoutes", null);
Permission = __decorate([Module({
  dynamic: true,
  store,
  name: 'permission'
})], Permission);
export const PermissionModule = getModule(Permission);